import { SET_DOWNLOAD_XOSC_FILE_REQUEST,
         SET_DOWNLOAD_XOSC_FILE_SUCCESS,
         SET_DOWNLOAD_XOSC_FILE_ERROR,
         SET_DOWNLOAD_XOSC_FILE_RESET,

         SET_DOWNLOAD_GROUND_TRUTH_FILE_REQUEST,
         SET_DOWNLOAD_GROUND_TRUTH_FILE_SUCCESS,
         SET_DOWNLOAD_GROUND_TRUTH_FILE_ERROR,
         SET_DOWNLOAD_GROUND_TRUTH_FILE_RESET,

         SET_AVAILABLE_KPI_LIST_REQUEST,
         SET_AVAILABLE_KPI_LIST_SUCCESS,
         SET_AVAILABLE_KPI_LIST_ERROR,
         SET_AVAILABLE_KPI_LIST_RESET,
         SET_ENABLE_SPECIFIC_KPI,
         SET_SELECT_ALL_AVAILABLE_KPI,
         SET_DESELECT_ALL_AVAILABLE_KPI,

         SET_DOWNLOAD_KPI_FILES_REQUEST,
         SET_DOWNLOAD_KPI_FILES_SUCCESS,
         SET_DOWNLOAD_KPI_FILES_ERROR,
         SET_DOWNLOAD_KPI_FILES_RESET } from './../../../../constants/closeLoop/kpiDashboard/download/downloadReportsConstants';
import { graphOptions } from './../../../../components/closedLoop/kpiDashboard/visualization/options/options';

const INITIAL_STATE = {
    loading: false,
    error: '',
    scenarioFileName: ''
}

export const downloadScenarioXOSCFile = (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_DOWNLOAD_XOSC_FILE_REQUEST:
            return {
                ...state,
                loading: true,
                error: ''
            }

        case SET_DOWNLOAD_XOSC_FILE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: '',
                scenarioFileName: action.payload
            }

        case SET_DOWNLOAD_XOSC_FILE_ERROR:
            return {
                ...state,
                loading: false,
                scenarioFileName: '',
                error: action.payload
            }

        case SET_DOWNLOAD_XOSC_FILE_RESET:
            return INITIAL_STATE;

        default:
            return state;
    }
}


const GROUND_TRUTH_INITIAL_STATE = {
    loading: false,
    error: '',
    fileName: ''
};

export const downloadScenarioGroundTruthFile = (state=GROUND_TRUTH_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_DOWNLOAD_GROUND_TRUTH_FILE_REQUEST:
            return {
                ...state,
                loading: true,
                error: ''
            }

        case SET_DOWNLOAD_GROUND_TRUTH_FILE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: '',
                fileName: action.payload
            }

        case SET_DOWNLOAD_GROUND_TRUTH_FILE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        case SET_DOWNLOAD_GROUND_TRUTH_FILE_RESET:
            return GROUND_TRUTH_INITIAL_STATE;

        default:
            return state;
    }
}

const AVAILABLE_KPI_INITIAL_STATE = {
    loading: false,
    error: '',
    kpiList: []
}

export const fetchAvailableKPIReducer = (state=AVAILABLE_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_AVAILABLE_KPI_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                kpiList: []
            }

        case SET_AVAILABLE_KPI_LIST_SUCCESS:
            const availableKPI = [];
            if (action.payload) {
                for(const kpiName of action.payload) {
                    const foundKPI = graphOptions.find(
                        (item) => item['value'] === kpiName);
                    if (foundKPI) {
                        const kpi = {
                            ...foundKPI,
                            enabled: true
                        }
                        availableKPI.push(kpi);
                    }
                }
            }
            return {
                ...state,
                loading: false,
                error: '',
                kpiList: availableKPI
            }

        case SET_AVAILABLE_KPI_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
                kpiList: []
            }

        case SET_ENABLE_SPECIFIC_KPI:
            const { kpi, checked } = action.payload;
            const modKPIList = state.kpiList.map((info) => {
                if(info['value'] === kpi) {
                    info['enabled'] = checked
                    return info;
                }
                return info;
            })
            return {
                ...state,
                loading: false,
                error: '',
                kpiList: modKPIList
            }

        case SET_SELECT_ALL_AVAILABLE_KPI:
            return {
                ...state,
                loading: false,
                error: '',
                kpiList: state.kpiList.map((item) => {
                    item['enabled'] = true;
                    return item
                })
            }

        case SET_DESELECT_ALL_AVAILABLE_KPI:
            return {
                ...state,
                loading: false,
                error: '',
                kpiList: state.kpiList.map((item) => {
                    item['enabled'] = false;
                    return item
                })
            }

        case SET_AVAILABLE_KPI_LIST_RESET:
            return AVAILABLE_KPI_INITIAL_STATE;

        default:
            return state;
    }
}

const KPI_FILES_INITIAL_STATE = {
    loading: false,
    error: ''
}

export const downloadKPIFilesReducer = (state=KPI_FILES_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_DOWNLOAD_KPI_FILES_REQUEST:
            return {
                ...state,
                loading: true,
                error: ''
            }

        case SET_DOWNLOAD_KPI_FILES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: ''
            }

        case SET_DOWNLOAD_KPI_FILES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        case SET_DOWNLOAD_KPI_FILES_RESET:
            return KPI_FILES_INITIAL_STATE;

        default:
            return state;
    }
}
